import React from 'react'
import Button from '../elements/Button'
import NoticesHOC from '../modules/NoticesHOC'
import globals from '../globals'
import { withRouter } from 'react-router-dom'

const NoticeFailedPayment = (props) => {
    const handleClick = event => {
        event.preventDefault()
        props.hideNotice()
        props.history.push('/payment-and-invoices/pay-account')
    }

    return (
        <div className='text-center'>
            <h2>Account temporarily suspended</h2>
            <p className='mb-5 lh'>We’ve had a problem deducting your last payment for this service from your nominated account. You can restore your service(s) within 20 minutes by <a href='#' onClick={handleClick}>making a payment</a> by Credit Card. If you’d prefer to pay by Direct Debit please call our Billing Team on <a href='tel: 133938'><span className='bold'>13 39 38</span></a>.</p>
            <Button title='Make Payment' action={handleClick} />
        </div>
    )
}

export default withRouter(NoticesHOC(NoticeFailedPayment))



// WEBPACK FOOTER //
// ./resources/js/components/NoticeFailedPayment.js